// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Id } from "./Id";
import { IdFromJSON, IdFromJSONTyped, IdToJSON, IdToJSONTyped } from "./Id";

/**
 *
 * @export
 * @interface OGC3DTileset
 */
export interface OGC3DTileset {
  /**
   *
   */
  id: Id;
  /**
   *
   */
  timestep?: number | null;
}

/**
 * Check if a given object implements the OGC3DTileset interface.
 */
export function instanceOfOGC3DTileset(value: object): value is OGC3DTileset {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function OGC3DTilesetFromJSON(json: any): OGC3DTileset {
  return OGC3DTilesetFromJSONTyped(json, false);
}

export function OGC3DTilesetFromJSONTyped(json: any, ignoreDiscriminator: boolean): OGC3DTileset {
  if (json == null) {
    return json;
  }
  return {
    id: IdFromJSON(json["id"]),
    timestep:
      json["timestep"] === undefined
        ? undefined
        : json["timestep"] === null
        ? null
        : json["timestep"],
  };
}

export function OGC3DTilesetToJSON(json: any): OGC3DTileset {
  return OGC3DTilesetToJSONTyped(json, false);
}

export function OGC3DTilesetToJSONTyped(
  value?: OGC3DTileset | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: IdToJSON(value["id"]),
    timestep: value["timestep"],
  };
}
